import { useTranslation } from "react-i18next";
import { Choice } from "../types/commercial";
import { Range } from "./range";
import { ServiceType } from "./npsservicestypes";
import { TFunction } from "i18next";
import { useAuth } from "../Auth/AuthProvider";


export const useOptionNpsStore = () => {
  const { t } = useTranslation();

  const options = [
    { label: t('common.j_1'), value: Range.PreviousDay },
    { label: t('common.semaine_cours'), value: Range.CurrentWeek },
    { label: t('common.semaine_precedente'), value: Range.LastWeek },
    { label: t('common.mois_cours'), value: Range.CurrentMonth },
  ] as Choice[];

  return options;
};

export const useOptionNpsDrive = () => {
  const { t } = useTranslation();

  const optionNpsDrive = [
  { label: t('common.semaine_cours'), value: Range.CurrentWeek },
  { label: t('common.semaine_precedente'), value: Range.LastWeek },
  ] as Choice[];

  return optionNpsDrive;
};

export const useOptionNpsBarometer = () => {
  const { t } = useTranslation();

  const optionNpsBarometer =  [
  { label: t('common.semaine_cours'), value: Range.CurrentWeek },
  { label: t('common.mois_cours'), value: Range.CurrentMonth },
  ] as Choice[];

  return optionNpsBarometer;
};

export const useOptionClosingRate = () => {
  const { t } = useTranslation();
  const optionClosingRate = [
  { label: t('common.direct'), value: Range.Direct },
  { label: t('common.j_1'), value: Range.PreviousDay },
  { label: t('common.mois_cours'), value: Range.CurrentMonth },
  ];
  return optionClosingRate;
}

export const useOptionHyperPriceAnomaly = () => {
  const { t } = useTranslation();
  const optionHyperPriceAnomaly = [
  { label: t('common.direct'), value: Range.Direct },
  { label: t('common.j_1'), value: Range.PreviousDay },
  { label: t('common.mois_cours'), value: Range.CurrentMonth },
  ];

  return optionHyperPriceAnomaly;
}

export const useOptionMarketPriceAnomaly = () => {
  const { t } = useTranslation();
  const optionMarketPriceAnomaly = [
  { label: t('common.j_1'), value: Range.PreviousDay },
  ];
  return optionMarketPriceAnomaly;
}

export const useOptionEcom = () => {
  const { t } = useTranslation();
  const optionEcom = [
    { label: t('common.en_direct'), value: Range.Direct },
    { label: t('common.j_1'), value: Range.PreviousDay },
    { label: t('common.semaine_cours'), value: Range.CurrentWeek },
    { label: t('common.mois_cours'), value: Range.CurrentMonth },
  ];

  return optionEcom;
}

export const useOptionSlot = () => {
  const { t } = useTranslation();
  const optionSlot = [
  { label: t('common.today'), value: Range.Today },
  { label: t('common.next_day'), value: Range.NextDay },
  ];
  return optionSlot;
}


export const useOptionShrinkage = () => {
  const { t } = useTranslation();
  const optionShrinkage  = [
  { label: t('common.j_1'), value: Range.PreviousDay },
  { label: t('common.mois_cours'), value: Range.CurrentMonth },
  ];

  return optionShrinkage;
}

export const useOptionShrinkageDepartment = () => {
  const { t } = useTranslation();
  const optionShrinkageDepartment = [
  { label: t('common.j_1'), value: Range.PreviousDay },
  { label: t('common.semaine_cours'), value: Range.CurrentWeek },
  { label: t('common.mois_cours'), value: Range.CurrentMonth },
  ];
  return optionShrinkageDepartment;
}

export const useOptionFlop5 = () => {
  const { t } = useTranslation();
  const optionFlop5 = [
  { label: t('common.j_1'), value: Range.PreviousDay },
  { label: t('common.semaine_cours'), value: Range.CurrentWeek },
  ];
  return optionFlop5;
}

export const useOptionCommercial = () => {
  const { user } = useAuth();
  const { t } = useTranslation();
  const isFrench = user?.countryKey === 'FRA';
  const optionCommercialFr = [
  { label: t('common.direct'), value: "/commercial/live", range: Range.Direct },
  { label: t('common.j_1'), value: "/commercial/yesterday", range: Range.PreviousDay },
  { label: t('common.semaine_cours'), value: "/commercial/week", range: Range.CurrentWeek },
  { label: t('common.lastweek'), value: "/commercial/lastweek", range: Range.LastWeek },
  { label: t('common.mois_cours'), value: "/commercial/month", range: Range.CurrentMonth },
  { label: t('common.lastmonth'), value: "/commercial/lastmonth", range: Range.LastMonth },
  ];
  const optionCommercialBe = [
  { label: t('common.j_1'), value: "/commercial/yesterday", range: Range.PreviousDay },
  { label: t('common.semaine_cours'), value: "/commercial/week", range: Range.CurrentWeek },
  { label: t('common.mois_cours'), value: "/commercial/month", range: Range.CurrentMonth },
  ];

    return isFrench ? optionCommercialFr : optionCommercialBe;
}

export const useOptionDeava = () => {
  const { t } = useTranslation();
  const optionDeava = [
  { label: t('common.j_1'), value: Range.PreviousDay },
  { label: t('common.semaine_cours'), value: Range.CurrentWeek },
  { label: t('common.mois_cours'), value: Range.CurrentMonth },
  ];
  return optionDeava;
}

export const useOptionVAB = () => {
  const { t } = useTranslation();

  const optionVAB =  [
  { label: t('common.j_1'), value: Range.PreviousDay },
  ] as Choice[];

  return optionVAB;
};

export const useOptionNpsServices = (): Choice[] => { 
  const { t }: { t: TFunction } = useTranslation(); 

  return [
    { label: t('client.location'), value: ServiceType.Location },
    { label: t('client.spectacles'), value: ServiceType.Spectacle },
    { label: t('client.relais_colis'), value: ServiceType.RelaisColis }
  ];
};

export const useOptionDetention = () => {
  const { t } = useTranslation();
  const dateJ1 = `(${new Date(Date.now() - 24 * 60 * 60 * 1000).toLocaleDateString('fr-FR', {day:'2-digit', month:'2-digit', year:'2-digit'})})`;
  // --- SEMAINE ---
  const now = new Date();
  const monday = new Date(now.setDate(now.getDate() - (now.getDay() || 7) + 1));
  const sunday = new Date(new Date(monday).setDate(monday.getDate() + 6));

  const weekRange = `(${monday.toLocaleDateString('fr-FR', {day:'2-digit', month:'2-digit', year:'2-digit'})} - ${sunday.toLocaleDateString('fr-FR', {day:'2-digit', month:'2-digit', year:'2-digit'})})`;

  // --- MOIS ---
  const firstDay = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
  const lastDay = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0);

  const monthRange = `(${firstDay.toLocaleDateString('fr-FR', {day:'2-digit', month:'2-digit', year:'2-digit'})} - ${lastDay.toLocaleDateString('fr-FR', {day:'2-digit', month:'2-digit', year:'2-digit'})})`;
  const optionClosingRate = [
  { label: `${t('common.j_1')} ${dateJ1}`, value: Range.PreviousDay },
  { label: `${t('common.semaine_cours')} ${weekRange}`, value: Range.CurrentWeek },
  { label:`${t('common.mois_cours')} ${monthRange}`, value: Range.CurrentMonth },
  ];
  return optionClosingRate;
}

export const useOptionDetentionPGC = (daySelected?: string) => {
  const { t } = useTranslation();
  const dateJ1 = `(${new Date(Date.now() - 24 * 60 * 60 * 1000).toLocaleDateString('fr-FR', {day:'2-digit', month:'2-digit', year:'2-digit'})})`;
  const dateJ2 = `(${new Date(Date.now() - 48 * 60 * 60 * 1000).toLocaleDateString('fr-FR', {day:'2-digit', month:'2-digit', year:'2-digit'})})`;

  // --- SEMAINE ---
  const now = new Date();
  const monday = new Date(now.setDate(now.getDate() - (now.getDay() || 7) + 1));
  const sunday = new Date(new Date(monday).setDate(monday.getDate() + 6));

  const weekRange = `(${monday.toLocaleDateString('fr-FR', {day:'2-digit', month:'2-digit', year:'2-digit'})} - ${sunday.toLocaleDateString('fr-FR', {day:'2-digit', month:'2-digit', year:'2-digit'})})`;

  // --- MOIS ---
  const firstDay = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
  const lastDay = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0);

  const monthRange = `(${firstDay.toLocaleDateString('fr-FR', {day:'2-digit', month:'2-digit', year:'2-digit'})} - ${lastDay.toLocaleDateString('fr-FR', {day:'2-digit', month:'2-digit', year:'2-digit'})})`;

  const isJ2 = daySelected === "J-2";

  return [
    { label: isJ2 ? `${t('common.j_2')} ${dateJ2}` : `${t('common.j_1')} ${dateJ1}`, value: Range.PreviousDay },
    { label: `${t('common.semaine_cours')} ${weekRange}`, value: Range.CurrentWeek },
    { label: `${t('common.mois_cours')} ${monthRange}`, value: Range.CurrentMonth },
  ] as Choice[];
}

export const useOptionRegion = () => {
  const { t } = useTranslation();
  return [
  { label: t('common.direct'), value: "/region/direct", range: Range.Direct },
  { label: t('common.j_1'), value: "/region/j-1", range: Range.PreviousDay },
  { label: t('common.semaine'), value: "/region/week", range: Range.CurrentWeek },
  { label: t('common.mois'), value: "/region/month", range: Range.CurrentMonth },
  ];
}